const withViewTimelineAnimation = (styles) => ({
  "@media (prefers-reduced-motion: no-preference)": {
    "@supports (animation-timeline: view())": styles
  }
});
export {
  withViewTimelineAnimation
};
//# sourceMappingURL=withViewTimelineAnimation.js.map
